import { parsePx } from '../hooks/useDimensions';

const DROPDOWN_DEFAULT_MAX_HEIGHT = 21;
// This value will ensure pagination is triggered and also menu popover will not overflow outside the screen
const SAFE_SPACE_HEIGHT = 3.25;

export const recalculateMaxHeight = (isMobile?: boolean) => {
  // get the height of the element with class name 'nextui-popover-content'
  const element = isMobile
    ? document.getElementById('modal_content')
    : (document.getElementsByClassName('nextui-popover-content-container')[0] as HTMLElement);

  if (!element) return undefined;

  const height = isMobile ? element.offsetHeight : parsePx(element.style.maxHeight);

  // We need to be able to trigger pagination
  let maxHeight = height / 16 - SAFE_SPACE_HEIGHT;
  if (maxHeight > DROPDOWN_DEFAULT_MAX_HEIGHT && !isMobile) maxHeight = DROPDOWN_DEFAULT_MAX_HEIGHT;

  return `${maxHeight}rem`;
};
